import api from './api';

const newsService = {
  async getAll(page = 1, limit = 10) {
    const response = await api.get('/news', { params: { page, limit } });
    return response.data;
  },

  async getOne(id) {
    const response = await api.get(`/news/${id}`);
    return response.data;
  },

  async create(data) {
    const response = await api.post('/news', data);
    return response.data;
  },

  async update(id, data) {
    const response = await api.patch(`/news/${id}`, data);
    return response.data;
  },

  async remove(id) {
    const response = await api.delete(`/news/${id}`);
    return response.data;
  },
};

export default newsService;
